import React from 'react';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './DepartmentEmpty.module.sass';
import { useDepartmentsPageTranslation } from '../i18n';

const displayName = 'DepartmentEmpty';
const testid = buildTestid(displayName);

function DepartmentEmpty(): React.JSX.Element {
  const { t } = useDepartmentsPageTranslation();

  return (
    <div
      className={st.Root}
      {...testid()}
    >
      <div className={st.EmptyImage} />
      <div className={st.EmptyText}>{t('empty', { context: 'page' })}</div>
    </div>
  );
}

DepartmentEmpty.displayName = displayName;

export { DepartmentEmpty };
